import React, { useState, useContext, useEffect } from "react";
import {
  NavLink,
  Outlet,
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { User, Users, FolderOpen, CreditCard, LogOut } from "lucide-react";
import { SessionContext } from "../../context/sessionContext";
import { useUser } from "../../context/UserContext";
import Cookies from "js-cookie";

const AdminLayout = () => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { logout, session } = useContext(SessionContext);
  const { userData, profilePicUrl, isLoading, roleName, getInitials } =
    useUser();
  const navigate = useNavigate();
  const location = useLocation();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "#000",
          color: "#fff",
        }}
      >
        Loading...
      </div>
    );
  }
  const username = userData?.username || "User";
  const initials = getInitials();

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate("/log-in", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/log-in", { replace: true });
    } finally {
      setIsLoggingOut(false);
      setShowUserMenu(false);
    }
  };
  const handleProjectsClick = (e) => {
    e.preventDefault();
    const isOnProjectsWithUserId =
      location.pathname === "/projects" && location.search.includes("user_id");
    if (isOnProjectsWithUserId) {
      window.location.href = "/projects";
    } else {
      navigate("/projects");
    }
  };

  return (
    <div className="admin-portal">
      <div className="admin-sidebar">
        <div className="logo">
          <Link to="/">
            <img
              src={"/json-media/img/logo.svg"}
              alt="GI"
              width={40}
              style={{ padding: 5, marginBottom: 10 }}
            />
          </Link>
        </div>

        <nav className="admin-nav">
          <NavLink
            to="/profile"
            title="Profile"
            className={({ isActive }) =>
              `admin-nav-btn ${isActive ? "active" : ""}`
            }
          >
            <User size={20} />
          </NavLink>

          <NavLink
            to="/members"
            title="Members"
            className={({ isActive }) =>
              `admin-nav-btn ${isActive ? "active" : ""}`
            }
          >
            <Users size={20} />
          </NavLink>

          <NavLink
            to="/projects"
            title="My Project"
            onClick={handleProjectsClick}
            className={({ isActive }) =>
              `admin-nav-btn ${isActive ? "active" : ""}`
            }
          >
            <FolderOpen size={20} />
          </NavLink>

          <NavLink
            to="/subscription"
            title="Subscription"
            className={({ isActive }) =>
              `admin-nav-btn ${isActive ? "active" : ""}`
            }
          >
            <CreditCard size={20} />
          </NavLink>
        </nav>

        <div className="admin-user-menu">
          <button
            className="admin-user-avatar"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            {profilePicUrl ? (
              <img
                src={profilePicUrl}
                alt="User"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              initials
            )}
          </button>

          {showUserMenu && (
            <div className="user-dropdown">
              <div className="dropdown-user-info">
                <p>{username}</p>
                <p>{roleName}</p>
              </div>

              <button
                className="logout-btn"
                onClick={handleLogout}
                disabled={isLoggingOut}
              >
                <LogOut size={16} />
                <span>{isLoggingOut ? "Logging out..." : "Logout"}</span>
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
